import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Sirve para todos los años de la técnica?',
    a: 'Sí. El Kit está organizado para que puedas usarlo desde 3° hasta 6° año. El Tomo 6 incluye planificaciones anuales diferenciadas por año de cursada.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Es 100% digital. Descargás todos los PDFs al instante y los podés usar en clase, compartir por WhatsApp con tus alumnos o imprimir para el taller.'
  }, {
    q: '¿Está actualizado a la norma AEA 90364 vigente?',
    a: 'Sí. Todo el contenido técnico está alineado a la Reglamentación AEA 90364 vigente en Argentina. No es material importado ni adaptado de otras normativas.'
  }, {
    q: '¿Qué lo diferencia del material que encuentro en internet?',
    a: 'El material que encontrás online es genérico, viejo o no cumple la normativa argentina. Este Kit fue creado específicamente para el taller de la escuela técnica argentina, con la lógica curricular del nivel secundario técnico.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tenés 7 días para probarlo en el aula. Si no te sirve, te devolvemos el 100% sin preguntas.'
  }, {
    q: '¿Puedo usarlo si soy maestro de taller y no profesor de teoría?',
    a: 'Absolutamente. El Kit está diseñado para los dos roles. Los maestros de taller van a encontrar en las fichas prácticas su recurso central. Los profesores de teoría van a usar los tomos y los bancos de ejercicios.'
  }, {
    q: '¿Los proyectos integradores incluyen las soluciones?',
    a: 'Sí, los 3 proyectos del upsell vienen con toda la documentación técnica resuelta para que el docente tenga la referencia clara al momento de corregir.'
  }, {
    q: '¿Puedo editar las evaluaciones y planificaciones?',
    a: 'Sí, el Tomo 6 incluye enlaces a versiones editables de las planificaciones anuales y modelos de examen para que puedas adaptarlos a tu escuela.'
  }, {
    q: '¿Sirve para escuelas de oficios o formación profesional?',
    a: 'Sí, los contenidos técnicos, fichas prácticas y rúbricas son perfectamente aplicables a cursos de formación profesional de electricista instalador.'
  }, {
    q: '¿Hay que pagar mensualidad?',
    a: 'No. Es un pago único. Comprás el kit hoy y te queda para siempre, sin suscripciones ni pagos ocultos.'
  }];
  return <section className="py-10 md:py-16 px-4 bg-brand-card" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-8 text-white" data-id="element-55">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-3" data-id="element-56">
          {faqs.map((faq, index) => <div key={index} className={`bg-brand-dark rounded-lg border ${openIndex === index ? 'border-brand-accent/50' : 'border-white/10'} overflow-hidden transition-all duration-200`} data-id="element-57">
              <button className="w-full px-4 py-3 md:px-5 md:py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-58">
                <span className={`font-bold text-sm md:text-base pr-4 ${openIndex === index ? 'text-brand-accent' : 'text-gray-200'}`} data-id="element-59">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-accent shrink-0" data-id="element-60" /> : <ChevronDown className="w-5 h-5 text-gray-600 shrink-0" data-id="element-61" />}
              </button>

              <div className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-62">
                <p className="text-sm md:text-base text-gray-400 leading-relaxed pt-2 border-t border-white/5" data-id="element-63">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}